import {
    SAVE_FCM_TOKEN_URL,
    SAVE_BID_WEB2,
    GET_OWNED_NFTS,
    SAVE_EXTERNAL_WALLET,
    TRANSFER_NFT_ASSET,
    CONFIRM_PAYMENT_METHOD,
    SAVE_SOCIAL_HANDLE,
    PERK,
    SAVE_BID_WEB2_INDIA,
    RAZORPAY_PAYMENT_SUCCESS,
    MINT_NFT_FOR_USER,
    GLIPBOX_LEFT,
    AIRDROP_NFT_FOR_USER,
    FETCH_NFT_METADATA,
    OVERLAY_DATA,
    FETCH_PAYMENT_CONFIG,
    FETCH_USER_PAYMENT_CONFIG
} from '../constants/urls';
import {getLoginInformation} from './loginHelper';


export async function setFCMTokenOnBackend(
    fcmToken, publicKey, creatorUsername){
    console.log('setting token')
    let resp = await fetch(SAVE_FCM_TOKEN_URL, {
	method: 'POST',
	headers: {
	    'Accept': 'application/json',
	    'Content-Type': 'application/json'
	},
	body: JSON.stringify({
	    fcmToken:fcmToken,
	    publicKey:publicKey,
	    creatorUsername:creatorUsername
	})
    });
    console.log(resp);
}


export async function sendBidToBackend(
    bidValue, auctionId, assetId, bidderMessage){
    let loginInformation = getLoginInformation();
    console.log('bidder message', bidderMessage);
    try{
        let resp = await fetch(SAVE_BID_WEB2, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
	    body: JSON.stringify({
                assetId: assetId,
                auctionId: auctionId,
                value: bidValue,
                bidderMessage:bidderMessage
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }    
}

export async function fetchOwnedNFTs(address){
    let loginInformation = getLoginInformation();
    let url = GET_OWNED_NFTS + `${address}`
    try{
        let resp = await fetch(url, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }    
}

export async function savePublicAddressToBackend(address){
    let loginInformation = getLoginInformation();
    let url = SAVE_EXTERNAL_WALLET;
    try{
        let resp = await fetch(url, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
            body: JSON.stringify({
	        externalAddress: address
	    })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}

export async function transferAsset(assetId, type){
    let loginInformation = getLoginInformation();
    let url = TRANSFER_NFT_ASSET + `${assetId}` + '?itemType=' + type;
    try{
        let resp = await fetch(url, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}

export async function confirmSavedPaymentMethod(){
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(CONFIRM_PAYMENT_METHOD, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }    
}

export async function setSocialHandleOnBackend(
    instagramHandle, discordHandle){
    let loginInformation = getLoginInformation();
    console.log('loginInformation', loginInformation);
    try{
        let resp = await fetch(`${SAVE_SOCIAL_HANDLE}${loginInformation.user.uid}`, {
	    method: 'PUT',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
	    body: JSON.stringify({
                "social":{
                    "instagram": instagramHandle,
                    "discord": discordHandle
                }
            })
        });
        resp = await resp.json();
        localStorage.setItem(
            'social-information', JSON.stringify(
                resp.data.user.social));
        return resp
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }    
}

export async function fetchLocation(){
    let url = 'https://geoip.parth.xyz/check';
    let resp = await fetch(url, {
	    method: 'GET',
    });
    try{
        resp = await resp.json();
    }
    catch(e){
        return;
    }
    return resp;
}

export async function sendMessagePerk(
    message, creator, serial, perk){
    let loginInformation = getLoginInformation();
    console.log('loginInformation', loginInformation);
    try{
        let resp = await fetch(`${PERK}`, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
	    body: JSON.stringify({
            perksData: {
                    "message": message,
                    "creator": creator,
                    "serial": serial,
                    "perk": perk,
                    "user": loginInformation.user
                }
            })
        });
        resp = await resp.json();        
        return resp
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }    
}

export async function sendIndiaBidToBackend(
    bidValue, auctionId, assetId){
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(SAVE_BID_WEB2_INDIA, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
	    body: JSON.stringify({
                assetId: assetId,
                auctionId: auctionId,
                value: bidValue,
                currency: 'INR'
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }
}

export async function sendPaymentInfoToBackend(orderId, paymentId){
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(RAZORPAY_PAYMENT_SUCCESS, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
	    body: JSON.stringify({
                orderId: orderId,
                paymentId: paymentId
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}

export async function mintNFT(creator, user){
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(MINT_NFT_FOR_USER, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
	    body: JSON.stringify({
            creator: creator,
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}

export async function fethchGlipBox(creator, user){
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(GLIPBOX_LEFT + '?creator=' + creator, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },	   
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}

export async function airdropNFT(creator, user, name, passId){
    let loginInformation = getLoginInformation();
    try{
        let resp = await fetch(AIRDROP_NFT_FOR_USER, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                "Authorization": `Token ${loginInformation.accessToken}`,
	    },
	    body: JSON.stringify({
            creator: creator,
            test: 1,
            name: name,
            passId: passId
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}



export async function fetchMetadata(contract, token){
    try{
        let resp = await fetch(FETCH_NFT_METADATA + `${contract}/${token}/`, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
	    },
        });	    
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}

export async function fetchOverlayData(token) {
    try {
        let resp = await fetch(OVERLAY_DATA, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": `Token ${token}`,
                // "Authorization": `Token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2MyIsImF1dGgiOnRydWUsImlhdCI6MTY2MzMzMTY5MCwiZXhwIjoxNjY1OTIzNjkwfQ.OH8_GDjODozi9EAka4s92V1yIL5A4cJHVpc1s3DQWbI`,
            },
        });
        resp = await resp.json();
        return resp
    }
    catch (e) {
        console.log('erororororo', e);
        return false;
    }
}

export async function fetchOverlayDataUser(userId) {
    try {
        let resp = await fetch(OVERLAY_DATA + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                // "Authorization": `Token ${token}`,
                // "Authorization": `Token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2MyIsImF1dGgiOnRydWUsImlhdCI6MTY2MzMzMTY5MCwiZXhwIjoxNjY1OTIzNjkwfQ.OH8_GDjODozi9EAka4s92V1yIL5A4cJHVpc1s3DQWbI`,
            },
        });
        resp = await resp.json();
        return resp
    }
    catch (e) {
        console.log('erororororo', e);
        return false;
    }
}

export async function sendOverlayData(config, token){    
    try {
        let data = new FormData();
        let file = false;
        for (let key in config) {
            if (config[key].type === 'image') {
                data.append('file', config[key].form[0].value[0]);
                file = true;         
            } 
        }
        if (file) {
            data.append('data', JSON.stringify(config));
            let headers = {
                'Accept': 'application/json',
                "Authorization": `Token ${token}`,
                // "Authorization": `Token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2MyIsImF1dGgiOnRydWUsImlhdCI6MTY2MzMzMTY5MCwiZXhwIjoxNjY1OTIzNjkwfQ.OH8_GDjODozi9EAka4s92V1yIL5A4cJHVpc1s3DQWbI`,
            };            
            let resp = await fetch(OVERLAY_DATA, {
                method: 'POST',
                headers: headers,
                body: data
            });
            resp = await resp.json();
            return resp
        
        } else {
            let resp = await fetch(OVERLAY_DATA, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `Token ${token}`,
                    // "Authorization": `Token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2MyIsImF1dGgiOnRydWUsImlhdCI6MTY2MzMzMTY5MCwiZXhwIjoxNjY1OTIzNjkwfQ.OH8_GDjODozi9EAka4s92V1yIL5A4cJHVpc1s3DQWbI`,
                },
                body: JSON.stringify({
                    data: config
                })
            });
            resp = await resp.json();
            return resp
        }               
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }
}

export async function fetchPaymentConfigFromBackend(username){
    try {
        let resp = await fetch(`${FETCH_PAYMENT_CONFIG}?name=${username}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }
}



export async function fetchUserPaymentConfigFromBackend(username){
    let loginInformation = getLoginInformation();
    try {
        let resp = await fetch(
            `${FETCH_USER_PAYMENT_CONFIG}?name=${username}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `Token ${loginInformation.accessToken}`,
                },
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e)
        return false;
    }
}
